import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Trucks from "./pages/Trucks";
import Trailers from "./pages/Trailers";
import Tyres from "./pages/Tyres";
import VehicleDetail from "./pages/VehicleDetail";
import CostReport from "./pages/CostReport";
import AlertsPage from "./pages/Alerts";
import TyreCatalogPage from "./pages/TyreCatalog";
import UsersPage from "./pages/Users";
import VehicleReport from "./pages/VehicleReport";
import SparepartMaster from "./pages/SparepartMaster";
import SparepartInventory from "./pages/SparepartInventory";
import Logbook from "./pages/Logbook";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="trucks" element={<Trucks />} />
            <Route path="trailers" element={<Trailers />} />
            <Route path="tyres" element={<Tyres />} />
            <Route path="alerts" element={<AlertsPage />} />
            <Route
              path="tyre-catalog"
              element={
                <ProtectedRoute roles={["management"]}>
                  <TyreCatalogPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="users"
              element={
                <ProtectedRoute roles={["management"]}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route path="vehicles/:type/:id" element={<VehicleDetail />} />
            <Route
              path="reports/cost"
              element={
                <ProtectedRoute roles={["management"]}>
                  <CostReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="reports/vehicle"
              element={
                <ProtectedRoute roles={["management"]}>
                  <VehicleReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="sparepart-master"
              element={
                <ProtectedRoute roles={["management"]}>
                  <SparepartMaster />
                </ProtectedRoute>
              }
            />
            <Route path="sparepart-inventory" element={<SparepartInventory />} />
            <Route path="logbook" element={<Logbook />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
